import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./components/home";
import MealPlanDisplay from "./components/meal-planner/MealPlanDisplay";
import ShoppingList from "./components/meal-planner/ShoppingList";
import MealPlansPage from "./components/meal-planner/MealPlansPage";
import AuthForm from "./components/auth/AuthForm";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import TermsOfService from "./components/legal/TermsOfService";
import FavoritesPage from "./components/meal-planner/FavoritesPage";
import { useAuth } from "./lib/auth";
import { useShufersalCredentials } from "./lib/hooks/useShufersalCredentials";
import { translations } from "./lib/translations";

function App() {
  const { user, loading } = useAuth();
  const { hasCredentials } = useShufersalCredentials();

  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center">
        <p>{translations.common.loading}</p>
      </div>
    );
  }

  return (
    <Suspense fallback={<p>{translations.common.loading}</p>}>
      <Routes>
        <Route
          path="/"
          element={
            user ? <MealPlansPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/new-plan"
          element={
            user ? <Home /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/meal-plan/:id"
          element={
            user ? <MealPlanDisplay /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/shopping-list"
          element={
            user ? <ShoppingList /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/favorites"
          element={
            user ? <FavoritesPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/login"
          element={
            user && hasCredentials ? (
              <Navigate to="/" replace />
            ) : (
              <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 p-4">
                <AuthForm />
              </div>
            )
          }
        />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
    </Suspense>
  );
}

export default App;
